import React from "react";
import { subDays } from "date-fns/subDays";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { dateFilterOptions } from "../../config/constant";

const FilterControls = ({ dateFilters, setDateFilters }) => {
  // Helper function to update dateFilters state
  const updateFilter = (key, value) => {
    setDateFilters((prev) => ({ ...prev, [key]: value }));
  };

  // Handle Filter Change
  const handleFilterOnChange = (event) => {
    const value = event.target.value;
    const dateRanges = {
      last_3_days: subDays(new Date(), 3),
      last_7_days: subDays(new Date(), 7),
      last_30_days: subDays(new Date(), 30),
    };

    setDateFilters((prev) => ({
      ...prev, // Spread previous state to retain other properties
      filterBy: value,
      startDate: dateRanges[value] || null, // Use predefined range or null for "custom"
      endDate: value === "custom" ? null : new Date(), // Null if "custom", else today
    }));
  };
  // Render either Date Filter or Text Input based on selection
  const renderFilterInput = () => (
    <FormControl size="small" fullWidth>
      <InputLabel>Date</InputLabel>
      <Select
        label="Date"
        value={dateFilters.filterBy || ""}
        onChange={handleFilterOnChange}
        // displayEmpty
      >
        {dateFilterOptions.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  // Render Date Inputs if "Custom Date Range" is selected
  const renderDateInputs = () =>
    dateFilters.selected === "date" &&
    dateFilters.filterBy === "custom" && (
      <div className="flex items-center space-x-4">
        {["startDate", "endDate"].map((dateType) => (
          <input
            key={dateType}
            type="date"
            value={
              dateFilters[dateType]
                ? dateFilters[dateType].toISOString().split("T")[0]
                : ""
            }
            onChange={(e) => {
              const newValue = e.target.value ? new Date(e.target.value) : null;
              updateFilter(dateType, newValue);
            }}
            className="p-2 rounded border border-gray-300"
          />
        ))}
      </div>
    );

  return (
    <div className="flex flex-col gap-4 p-2">
      {renderFilterInput()}
      {renderDateInputs()}
    </div>
  );
};

export default FilterControls;
